import { makeAutoObservable } from 'mobx';

export class BetHistoryItem {
  constructor({ price, timestamp }) {
    makeAutoObservable(this);

    this.price = price;
    this.timestamp = timestamp;
  }
  price;
  timestamp;
}
